import { render, staticRenderFns } from "./FunnelChartCommon.vue?vue&type=template&id=b2f9b5d2&scoped=true&"
import script from "./FunnelChartCommon.vue?vue&type=script&lang=js&"
export * from "./FunnelChartCommon.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChartCommon.vue?vue&type=style&index=0&id=b2f9b5d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f9b5d2",
  null
  
)

export default component.exports